<template>
  <div class="CS-footer pdb-9 pdt-10 fixed-CS-Footer">
    <div style="margin-top:unset;">
      <div class="d-flex align-items-center justify-content-end mgr-20">
        <div class="d-flex align-items-center justify-content-end">
          <div class="d-flex align-items-center">
            <like-and-bookmark
                :clipping="clipping"
                :clippingCount="clippingCount"
                :likes="likes"
                :likesCount="likesCount"
                @updateBookmarkCount="updateBookmarkCount"
                @updateLikesCount="updateLikesCount"
            ></like-and-bookmark>
          </div>
        </div>
        <button :class="lightModeActive ? 'bg-contentPlayerBgLight' : 'bg-secondaryBtn'"
                class="mdc-button t-color-contentText min-w-auto mdc-button--raised mgl-24"
                @click="setisQuestionAns" @keypress="setisQuestionAns">
          <div class="mdc-button__ripple"></div>
          <span class="mdc-button__label t-body2 font-r">{{ $t('3728') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",

  props: ['lightModeActive', 'lessonData'],

  components: {
    'like-and-bookmark': () => import('@/components/study/LikeAndBookmark'),
  },

  data() {
    return {
      // 북마크 좋아요 관련 데이터(like & bookmark data)
      isLiked: false,
      isBookmarked: false,
      likes: false,
      likesCount: 0,
      clipping: false,
      clippingCount: 0,
    }
  },

  mounted() {
    this.likes = this.lessonData.likes;
    this.likesCount = this.lessonData.likesCount;
    this.clipping = this.lessonData.clipping;
    this.clippingCount = this.lessonData.clippingCount;
  },

  methods: {
    darkModeToLight() {
      this.$emit('darkModeToLight');
    },

    setisQuestionAns() {
      this.$emit('setisQuestionAns');
    },

    // update likes count
    updateLikesCount(data) {
      this.likes = data.likes;
      this.likesCount = data.likesCount;
    },

    // update bookmark count
    updateBookmarkCount(data) {
      this.clipping = data.clipping;
      this.clippingCount = data.clippingCount;
    },
  }
}
</script>

<style scoped>
.footer {
  bottom: 0;
  border-top: 0.1rem solid #1d202e;
  background-color: #263747;
}
</style>
